import React from "react";
import "./CenteredHeader.scss"

function CenteredHeader({ yellowText, boldText, route }) {
  return (
    <div className={`centered-header-container max-width ${route}`}>
      <h4 className={`t5 c-yellow centered-header-yellow-header no-space mb-20 ${route}`}>
        {yellowText}
      </h4>
      <h2 className="t3 centered-header-bold-header no-space">{boldText}</h2>
    </div>
  );
}

export default CenteredHeader;
